import axios from 'config/axios'

const REQUESTER_SERVICE_HEADER = {
  KEY: 'X-Nu-Requester-Service',
  VALUE: 'nuinvest-webapp'
}

export const getEarnings = permalink => {
  const path = permalink ? permalink : 'current'//eslint-disable-line

  return axios.get(`/shell-acompanhar/earnings/summary/${path}`, {
    headers: { [REQUESTER_SERVICE_HEADER.KEY]: REQUESTER_SERVICE_HEADER.VALUE }
  })
}

export default getEarnings

